import React from "react";
import TopBar from "./TopBar";
import "./header.css";
import MainBar from "./MainBar";

export default function Header() {
  return (
    <header className="shadow">
      <TopBar />
      <MainBar />
    </header>
  );
}
